const storageNames = {
	aBTesting: 'A_B_TESTING',
	actionTracking: 'CAMPAIGN_TRACKING',
	auditEvents: 'AUDIT_EVENTS',
	auditEventsDate: 'AUDIT_EVENTS_DATE',
	authToken: 'CDC_TOKEN',
	campaignData: 'CAMPAIGN_DATA',
	careCenterInternalRoute: 'CARE_CENTER_INTERNAL_ROUTE',
	cognitoToken: 'TOKEN_INFO',
	flagFirstEntry: 'flagFirstEntry',
	flagUserEmail: 'userWithoutLogin',
	gigyaToken: 'GIGYA_TOKEN',
	gigyaUID: 'GIGYA_UID',
	intoCampaign: 'CAMPAIGN_INTO',
	isInstallApp: 'IS_INSTALL_APP',
	isMigrate: 'MIGRATE',
	isUserRegistered: 'REGISTERED_USER',
	metricContentCampaign: 'CAMPAIGN_CONTENT',
	notification: 'NOTIFICATION',
	notification_push: 'NOTIFICATION_PUSH_ID',
	NPS_ID: 'NPS_ID',
	routineVisibleAlly: 'MY_ROUTINE_VISIBLE_ALLY',
	toolDiabetesModal: 'DIABETES_MODAL',
	tooltipList: 'TOOLTIP_LIST',
	gigyaScreen: 'gigyaScreen'
}

export default storageNames
